import { isFeatureEnabled } from 'owa-feature-flags';
import { isMonarchMultipleAccountsEnabled } from 'owa-account-source-list';

export default function isMultiAccountsCombinedFavoritesEnabled() {
    return isFeatureEnabled('tri-favorites-roaming') && isMonarchMultipleAccountsEnabled();
}
